'use strict';
import angular from 'angular';

angular.module('widget.daterange.ctrls', []);